// client/src/seoRoutes.js — routes for search & social metadata, in one file (App.js
// spreads these, the same way as wave2Routes.js).
import React from 'react';
import { Route } from 'react-router-dom';
import SeoLandingPage from './pages/SeoLandingPage';
import SeoSettingsPage from './pages/secure/SeoSettingsPage';

/** Under the public layout: the generated city landing pages (routes/seoPublic.js). */
export const seoPublicRoutes = () => [
    <Route key="seo-list" path="list-your-property/:city" element={<SeoLandingPage kind="list" />} />,
    <Route key="seo-lease" path="commercial-space-for-lease/:city" element={<SeoLandingPage kind="lease" />} />,
];

/** Under /dashboard: Administration → Search & Social Metadata (managing broker). */
export const seoDashboardRoutes = () => [
    <Route key="seo-settings" path="seo" element={<SeoSettingsPage />} />,
];
